<template>
  <div class="container">
    <p class="title">{{ q }}</p>
    <div
      :style="{
        width: '350px',
        maxWidth: '100%'
      }"
    >
      <p
        class="option"
        :class="selectedValues.find(v => v === item) ? 'item-selected' : 'item'"
        v-for="item in a"
        :key="item.answer"
        @click="handleClick(item)"
      >
        {{ item.answer }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "QandA",
  props: {
    q: { required: true, default: "" },
    a: { type: Array }
  },
  data() {
    return {
      selectedValues: []
    };
  },
  updated() {
    this.updateClasses();
  },
  methods: {
    handleClick(val) {
      const indexOf = this.selectedValues.indexOf(
        this.selectedValues.find(v => v.answer === val.answer)
      );
      if (indexOf === -1) {
        this.selectedValues.push(val);
      } else {
        this.selectedValues.splice(indexOf, 1);
      }
      this.updateClasses();
      this.$emit("select", this.selectedValues);
    },
    updateClasses() {
      var options = this.$el.querySelectorAll(".option");
      var answers = this.selectedValues.map(v => v.answer);
      options.forEach(o => {
        o.classList.toggle("item-selected", answers.includes(o.innerText));
        o.classList.toggle("item", !answers.includes(o.innerText));
      });
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  margin-bottom: 0;
  align-self: center;
}

.item,
.item-selected {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border: 2px solid #31b9be;
  border-radius: 20px;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
}

.item-selected {
  background-color: #31b9be;
  color: #fff;
}
</style>
